// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";

import { Segment, Form, Grid, Accordion, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import _ from "lodash";

import TrialSearchResultsForDashboard from "../Trials/TrialSearch/TrialSearchResultsForDashboard";
import TrialMetaFactorsModal from "../Trials/TrialMetaTags/TrialMetaFactorsModal.tsx";

const TrialSearch = ({
	unfilteredTrialList,
	filteredTrialList,
	trialStatuses,
	setTrialName,
	setTrialOwner,
	setCooperator,
	setCity,
	setRegion,
	setCountry,
	setCompany,
	setDefStatus,
	loading,
	reset,
}) => {
	//-- Search Options
	const [name, setName] = useState(null);
	const [owner, setOwner] = useState(null);
	const [trialCooperator, setTrialCooperator] = useState(null);
	const [trialCity, setTrialCity] = useState(null);
	const [trialRegion, setTrialRegion] = useState(null);
	const [trialCountry, setTrialCountry] = useState(null);
	const [trialCompany, setTrialCompany] = useState(null);
	const [trialDEFStatus, setTrialDEFStatus] = useState(null);

	const [metaFactorModalOpen, setMetaFactorsModalOpen] = useState(false);
	const [modalTrialId, setModalTrialId] = useState("");
	const [modalTrialName, setModalTrialName] = useState("");

	const defStatusOptions = [{ key: "All", value: "All", text: "All" }]
		.concat([{ key: "Exclusions", value: "Exclusions", text: "Exclusions Only" }])
		.concat([{ key: "Flags", value: "Flags", text: "Flags Only" }])
		.concat([{ key: "Both", value: "Both", text: "Flags & Exclusions" }])
		.concat([{ key: "No Annotations", value: "No Annotations", text: "No Annotations" }]);

	//-- UI Control
	const [accordionActive, setAccordionActive] = useState(true);

	//-- Resets all fields
	useEffect(() => {
		setName(null);
		setOwner(null);
		setTrialCooperator(null);
		setTrialCity(null);
		setTrialRegion(null);
		setTrialCompany(null);
		setTrialDEFStatus(null);
	}, [reset]);

	//-- Sends trial name back up to parent search page
	useEffect(() => {
		setTrialName(name);
	}, [name]);

	//-- Sends trial owner back up to parent search page
	useEffect(() => {
		setTrialOwner(owner);
	}, [owner]);

	//-- Sends cooperator back up to parent search page
	useEffect(() => {
		setCooperator(trialCooperator);
	}, [trialCooperator]);

	//-- Sends city back up to parent search page
	useEffect(() => {
		setCity(trialCity);
	}, [trialCity]);

	//-- Sends region back up to parent search page
	useEffect(() => {
		setRegion(trialRegion);
	}, [trialRegion]);

	//-- Sends country back up to parent search page
	useEffect(() => {
		setCountry(trialCountry);
	}, [trialCountry]);

	//-- Sends company back up to parent search page
	useEffect(() => {
		setCompany(trialCompany);
	}, [trialCompany]);

	//-- Sends def status back up to parent search page
	useEffect(() => {
		setDefStatus(trialDEFStatus);
	}, [trialDEFStatus]);

	//-- Toggles accordian
	const handleAccordionClick = () => {
		setAccordionActive(!accordionActive);
	};

	const toggleMetaFactorModal = (trialId, trialName, open = true) => {
		if (trialId) {
			setModalTrialId(trialId);
			setModalTrialName(trialName);
			setMetaFactorsModalOpen(open);
		}
	};

	return (
		<>
			<Segment
				style={{
					marginTop: 10,
					backgroundColor: "var(--secondary-soy-bean-800)",
					border: "none",
					borderRadius: "8px",
				}}
			>
				<Accordion fluid>
					<Accordion.Title active={accordionActive} style={{ cursor: "unset", paddingBottom: 0 }}>
						<Grid>
							<Grid.Row style={{ paddingTop: 0, color: "white", gap: "12px" }}>
								<div
									onClick={() => handleAccordionClick()}
									style={{ cursor: "pointer", alignSelf: "end", margin: "0 1em" }}
								>
									<h2>
										<Icon name="dropdown" />
										Trials
									</h2>
								</div>

								<Form.Dropdown
									fluid
									className="dashboardInput solid"
									openOnFocus
									onChange={(event, { value }) => {
										setName(value);
									}}
									onSearchChange={(event, { searchQuery }) => {
										setName(searchQuery);
									}}
									options={_.uniqBy(
										_.map(loading ? [] : unfilteredTrialList, (t) => {
											return { text: t.trialName, value: t.trialName };
										}),
										"value",
									).sort((a, b) => (a.value > b.value ? 1 : -1))}
									placeholder="Trial Name/ID"
									search
									searchQuery={name ?? ""}
									selection
									selectOnBlur={false}
									type="text"
									value={name ?? ""}
									disabled={loading}
									onOpen={() => {
										setName("");
									}}
								/>

								<Form.Dropdown
									fluid
									className="dashboardInput solid"
									openOnFocus
									onChange={(event, { value }) => {
										setOwner(value);
									}}
									onSearchChange={(event, { searchQuery }) => {
										setOwner(searchQuery);
									}}
									options={_.uniqBy(
										_.map(
											loading
												? []
												: _.filter(unfilteredTrialList, (utl) => utl.trialOwnerFirstName && utl.trialOwnerLastName),
											(t) => {
												return {
													text: t.trialOwnerFirstName + " " + t.trialOwnerLastName,
													value: t.trialOwnerFirstName + " " + t.trialOwnerLastName,
												};
											},
										),
										"value",
									).sort((a, b) => (a.value > b.value ? 1 : -1))}
									placeholder="Trial Owner"
									search
									searchQuery={owner ?? ""}
									selection
									selectOnBlur={false}
									type="text"
									value={owner ?? ""}
									disabled={loading}
									onOpen={() => {
										setOwner("");
									}}
								/>

								<Form.Dropdown
									fluid
									className="dashboardInput solid"
									openOnFocus
									onChange={(event, { value }) => {
										setTrialCooperator(value);
									}}
									onSearchChange={(event, { searchQuery }) => {
										setTrialCooperator(searchQuery);
									}}
									options={_.uniqBy(
										_.map(loading ? [] : _.filter(unfilteredTrialList, (utl) => utl.cooperatorName), (t) => {
											return { text: t.cooperatorName, value: t.cooperatorName };
										}),
										"value",
									).sort((a, b) => (a.value > b.value ? 1 : -1))}
									placeholder="Cooperator"
									search
									searchQuery={trialCooperator ?? ""}
									selection
									selectOnBlur={false}
									type="text"
									value={trialCooperator ?? ""}
									disabled={loading}
									onOpen={() => {
										setTrialCooperator("");
									}}
								/>

								<Form.Dropdown
									fluid
									className="dashboardInput solid"
									openOnFocus
									onChange={(event, { value }) => {
										setTrialCity(value);
									}}
									onSearchChange={(event, { searchQuery }) => {
										setTrialCity(searchQuery);
									}}
									options={_.uniqBy(
										_.map(loading ? [] : _.filter(unfilteredTrialList, (utl) => utl.city), (t) => {
											return { text: t.city, value: t.city };
										}),
										"value",
									).sort((a, b) => (a.value > b.value ? 1 : -1))}
									placeholder="City"
									search
									searchQuery={trialCity ?? ""}
									selection
									selectOnBlur={false}
									type="text"
									value={trialCity ?? ""}
									disabled={loading}
									onOpen={() => {
										setTrialCity("");
									}}
								/>

								<Form.Dropdown
									fluid
									className="dashboardInput solid"
									openOnFocus
									onChange={(event, { value }) => {
										setTrialRegion(value);
									}}
									onSearchChange={(event, { searchQuery }) => {
										setTrialRegion(searchQuery);
									}}
									options={_.uniqBy(
										_.map(loading ? [] : _.filter(unfilteredTrialList, (utl) => utl.region), (t) => {
											return { text: t.region, value: t.region };
										}),
										"value",
									).sort((a, b) => (a.value > b.value ? 1 : -1))}
									placeholder="State / Region"
									search
									searchQuery={trialRegion ?? ""}
									selection
									selectOnBlur={false}
									type="text"
									value={trialRegion ?? ""}
									disabled={loading}
									onOpen={() => {
										setTrialRegion("");
									}}
								/>

								<Form.Dropdown
									fluid
									className="dashboardInput solid"
									openOnFocus
									onChange={(event, { value }) => {
										setTrialCountry(value);
									}}
									onSearchChange={(event, { searchQuery }) => {
										setTrialCountry(searchQuery);
									}}
									options={_.uniqBy(
										_.map(loading ? [] : _.filter(unfilteredTrialList, (utl) => utl.country), (t) => {
											return { text: t.country, value: t.country };
										}),
										"value",
									).sort((a, b) => (a.value > b.value ? 1 : -1))}
									placeholder="Country"
									search
									searchQuery={trialCountry ?? ""}
									selection
									selectOnBlur={false}
									type="text"
									value={trialCountry ?? ""}
									disabled={loading}
									onOpen={() => {
										setTrialCountry("");
									}}
								/>

								<Form.Dropdown
									fluid
									className="dashboardInput solid"
									openOnFocus
									onChange={(event, { value }) => {
										setTrialCompany(value);
									}}
									onSearchChange={(event, { searchQuery }) => {
										setTrialCompany(searchQuery);
									}}
									options={_.uniqBy(
										_.map(loading ? [] : _.filter(unfilteredTrialList, (utl) => utl.companyName), (t) => {
											return { text: t.companyName, value: t.companyName };
										}),
										"value",
									).sort((a, b) => (a.value > b.value ? 1 : -1))}
									placeholder="Company"
									search
									searchQuery={trialCompany ?? ""}
									selection
									selectOnBlur={false}
									type="text"
									value={trialCompany ?? ""}
									disabled={loading}
									onOpen={() => {
										setTrialCompany("");
									}}
								/>

								<Form.Dropdown
									fluid
									className="dashboardInput solid"
									openOnFocus
									onChange={(event, { value }) => {
										setTrialDEFStatus(value);
									}}
									options={defStatusOptions}
									placeholder="Annotation Status"
									search
									selection
									selectOnBlur={false}
									type="text"
									value={trialDEFStatus ?? ""}
									disabled={loading}
								/>
							</Grid.Row>
						</Grid>
					</Accordion.Title>
					<Accordion.Content active={accordionActive} style={{ maxHeight: "500px", overflowX: "auto", padding: 0 }}>
						<TrialSearchResultsForDashboard
							parentIsDashboard={true}
							trialList={loading ? [] : filteredTrialList}
							trialStatuses={trialStatuses}
							toggleMetaFactorModal={toggleMetaFactorModal}
						/>
					</Accordion.Content>
				</Accordion>
			</Segment>
			<TrialMetaFactorsModal
				open={metaFactorModalOpen}
				setOpen={setMetaFactorsModalOpen}
				trialId={modalTrialId}
				trialName={modalTrialName}
			/>
		</>
	);
};

TrialSearch.propTypes = {
	unfilteredTrialList: PropTypes.array,
	filteredTrialList: PropTypes.array.isRequired,
	trialStatuses: PropTypes.array.isRequired,
	setTrialName: PropTypes.func.isRequired,
	setTrialOwner: PropTypes.func.isRequired,
	setCooperator: PropTypes.func.isRequired,
	setCity: PropTypes.func.isRequired,
	setRegion: PropTypes.func.isRequired,
	setCountry: PropTypes.func.isRequired,
	setCompany: PropTypes.func.isRequired,
	setDefStatus: PropTypes.func.isRequired,
	loading: PropTypes.bool.isRequired,
	reset: PropTypes.bool.isRequired,
};

export default TrialSearch;
